import AccessDenied from "./assets/Svg/accessDenied";
import BenchLoader from "./Components/UIComponent/BenchLoader/BenchLoader";
import { useAppSelector } from "./hooks/hooks";
import { RootState } from "./store/store";
import {Text } from '@mantine/core'

interface ProtectedRouteProps {
  resourceId: string;
  element: JSX.Element;
}

const ProtectedRoute = ({ resourceId, element }: ProtectedRouteProps) => {
  const { permissions, loading: permissionLoader } = useAppSelector((state: RootState) => state.permissions);
  if (!permissions) return <div>Loading permissions...</div>;
  // Show loader while fetching permissions
  if (permissionLoader) return <div><BenchLoader isLoading={true}/></div>    ;

  const hasPageAccess = permissions?.[resourceId]?.read || false;
// console.log(permissions?.[resourceId], "protectedRoute");

  // If user does not have access, show error message
  if (!hasPageAccess) {
    return (
      <div style={{ textAlign: "center"}}>
        <AccessDenied />
        <Text color="red"> 🚫 You don't have permission to access this page.</Text>
        <Text>Please contact your administrator to request access.</Text>
      </div>
    );
  }



  return element;
};

export default ProtectedRoute;
